export enum CardActionTypeEnum {
  ADD = 'add',
  PATCH_QUANTITY = 'patchQuantity',
  DELETE = 'delete',
}
